<template>
  <v-app>
    <v-app-bar
      app
      color="rgba(255, 255, 255, .8)"
      flat
      height="80"
      class="header"
    >
      <v-img
        src="/img/symbol-green-2x.png"
        max-height="44"
        contain
        class="ml-2 flex-grow-0"
      />
      <v-spacer />
      <v-img
        src="/img/logo-grey-2x.png"
        max-height="24"
        contain
        class="flex-grow-0"
      />
      <v-spacer />

        <v-icon color="white">
          mdi-menu
        </v-icon>
    </v-app-bar>

    <v-main
      v-resize="onResize"
    >
      <v-sheet
        class="hero faded-bg pa-4 text-center d-flex flex-column justify-space-between"
      >
        <v-spacer />

        <h1 class="heading text-h3 text-sm-h2 secondary--text text--darken-1 mb-8 mb-sm-16">
          CBD & THC <br> <b class="font-weight-bold">totalmente legal.</b>
        </h1>

        <h2 class="subheading text-h6 text-sm-h4 secondary--text my-6">
          <b>Conectamos você a um médico ou veterinário especializado</b> <br class="d-none d-sm-inline"> para facilitar a assistência necessária.
        </h2>

        <v-spacer />

        <v-card-actions
          class="mb-8 mx-4"
        >
          <v-btn
            :block="views.viewport.w <= 720"
            depressed
            color="accent"
            x-large
            class="mx-auto px-6"
            @click="openBot"
          >
            Agende sua consulta
          </v-btn>
        </v-card-actions>
      </v-sheet>
      <v-container
        id="how"
        class="text-center my-8 px-8"
      >
        <h2 class="text-h4 font-weight-black accent--text my-8">
          Como funciona
        </h2>
        <v-carousel
          v-model="views.how.slider.step"
          :show-arrows="false"
          height="auto"
          progress
          cycle
          interval="8000"
          hide-delimiters
          light
          class="slider"
          style="min-height: 400px;"
        >
          <v-carousel-item
            v-for="step in views.how.slider.steps.length"
            :key="'how-step-'+step"
            eager
          >
            <!-- <v-chip
              v-if="step>1"
              color="secondary lighten-1"
              class="mb-4"
            >
              <span class="white--text text-subtitle-2 font-weight-black">{{ step-1 }}</span>
            </v-chip> -->
            <!-- <v-icon v-else>mdi-arrow-right</v-icon> -->
            <h3 class="text-h5 secondary--text text--darken-1">
              {{ views.how.slider.steps[step-1] }}
            </h3>
            <v-img
              :src="`/img/how-slider-step-${step}.jpg`"
              max-width="480px"
              contain
              class="mx-auto"
            />
          </v-carousel-item>
        </v-carousel>
        <v-btn
          :block="views.viewport.w <= 720"
          depressed
          color="accent"
          x-large
          class="mx-auto mt-8 px-6"
          @click="openBot"
        >
          Agende sua consulta
        </v-btn>
      </v-container>
      <v-container
        id="about"
        class="px-8 my-8 secondary--text text--darken-1"
      >
        <h2 class="text-h4 font-weight-black my-8 text-center">
          Sobre a Lega
        </h2>
        <p class="text-body-1">
          <b>A Lega é a MedTech que conecta o paciente ao médico ou veterinário prescritor e aos dispensários</b> para escolha e aquisição de tratamentos à base de canabinoides. <b>Nossa proposta é assistir o paciente em todo o processo de escolha por um tratamento</b>, do agendamento da consulta ao recebimento dos produtos em casa. Por meio da tecnologia, a Lega é a facilitadora que faz a ponte entre você e o seu tratamento.
        </p>
        <p class="text-body-1">
          <b>A cannabis é uma planta de potencial diverso</b>, que já vem sendo fortemente explorada nas indústrias têxtil e cosmetológica. <b>Aqui no Brasil há alguns anos ela vem sendo utilizada de forma legal para tratar dores crônicas, ansiedade, depressão, epilepsia, esclerose, alzheimer, parkinson, fibromialgia, autismo.</b>
        </p>
        <!-- <p class="text-body-1">
          A Lega nasce em meio a tabus e a uma legislação proibicionista, e o nosso propósito é por meio da tecnologia desmistificar, informar e dar acesso ao uso de medicamentos e produtos à base de canabinoides, como CBD e THC, proporcionando mais saúde, qualidade de vida e bem-estar, e impactando cada vez mais vidas.
        </p> -->
      </v-container>
      <v-footer
        dark
        padless
        color="transparent"
        class="mt-12"
      >
        <v-card
          flat
          tile
          width="100%"
          class="accent white--text text-center pt-4"
        >
          <v-card-text>
            <v-btn
              v-for="icon in views.footer.icons"
              :key="icon.url"
              class="mx-4 white--text"
              icon
              large
              :href="icon.url"
              target="_blank"
            >
              <v-icon medium>
                {{ icon.vector }}
              </v-icon>
            </v-btn>
          </v-card-text>

          <v-card-text class="white--text pt-0 pb-8">
            <a href="mailto:contato@legabrasil.com.br">contato@legabrasil.com.br</a>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text class="white--text">
            <strong>LEGA ®</strong> {{ new Date().getFullYear() }}
          </v-card-text>
        </v-card>
      </v-footer>
    </v-main>
  </v-app>
</template>

<style lang="scss">

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;500;700;900&display=swap');

$font-family: 'Inter';

#app {
  [class*='text-'] {
    font-family: $font-family, sans-serif !important;
  }
  font-family: $font-family, sans-serif !important;
}

.hero {
  min-height: calc(100vh - 120px);
  // min-height: -webkit-fill-available;
}
html {
  // height: -webkit-fill-available;
}

// .v-application {
//   font-family: "Inter", "Roboto", sans-serif !important;
// }

.heading, .subheading {
  line-height: 1.4em !important;
}

.faded-bg {
  background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), rgba(112, 122, 255, 0.08) !important;
}
.faded-bg-reverse {
  background: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), rgba(112, 122, 255, 0.08) !important;
}

body>div:last-child button {
  margin-top: -12px !important;
  opacity: .6 !important;
}

#app .header {
  backdrop-filter: blur(10px);
  box-shadow: 0 0 24px 8px rgba(255, 255, 255, 1) !important;
}

#how .slider .v-progress-linear {
  margin-top: -4px;
}

</style>

<script>

export default {
  name: 'Home',

  data: () => ({
    views: {
      how: {
        slider: {
          step: 1,
          steps: [
            'Comece agora o seu tratamento em casa em 4 passos simples.',
            'Agende sua consulta',
            'Fale com o médico ou veterinário',
            'Receba sua prescrição',
            'O serviço LEGA 360° toma conta do resto'
          ]
        }
      },
      footer: {
        icons: [
          {
            vector: 'mdi-instagram',
            url: 'https://instagram.com/lega.brasil'
          },
          {
            vector: 'mdi-email',
            url: 'mailto:contato@legabrasil.com.br'
          }
        ]
      },
      viewport: {
        w: 0,
        h: 0
      }
    }
  }),

  methods: {
    openBot () {
      console.log('openBot')
      //window.artibotApi.trigger('bot:expand')
      window.open('https://legabrasil.youcanbook.me/', '_blank');
    },
    botOpened () {
      console.log('botOpened')
    },
    onResize () {
      this.views.viewport = { w: window.innerWidth, h: window.innerHeight }
    }
  },
  mounted () {
    this.onResize()
  }
}
</script>
